import { SearchPage } from 'Components'
import TemplateSearchPage from 'Stores/randys-worldwide/Templates/SearchPage.rt'
import { FacetTiles } from 'Components'
import TemplatefacetTilessubtitles from 'Stores/_default-store/Templates/facetTiles/subtitles.rt'
import { FacetPanel } from 'Components'
import { FacetBar } from 'Components'
import { SearchResult } from 'Components'
import { SearchHeader } from 'Components'
import { VehicleWidget } from 'Components'
import TemplatefitmentSearchcollapsibleVehicleWidget from 'Stores/_default-store/Templates/fitmentSearch/collapsibleVehicleWidget.rt'
import { RequestPanel } from 'Components'
import TemplateHomeWheelTireBar from 'Stores/_default-store/Templates/HomeWheelTireBar.rt'
import { Garage } from 'Components'
import TemplatefitmentSearchgarage from 'Stores/_default-store/Templates/fitmentSearch/garage.rt'
import { SingleVehicleGarage } from 'Components'
import TemplatefitmentSearchsingleVehicleGarage from 'Stores/_default-store/Templates/fitmentSearch/singleVehicleGarage.rt'
import TemplatefacetTileshierarchicalContainer from 'Stores/_default-store/Templates/facetTiles/hierarchicalContainer.rt'
import TemplatefacetTilesalphabeticalContainer from 'Stores/_default-store/Templates/facetTiles/alphabeticalContainer.rt'
import { RelatedItems } from 'Components'
import TemplateproductrelatedItems from 'Stores/_default-store/Templates/product/relatedItems.rt'
import { BuyItemsTogether } from 'Components'
import TemplateproductboughtTogether from 'Stores/_default-store/Templates/product/boughtTogether.rt'
import { FacetDialog } from 'Components'
import TemplateFacetDialogVehicleSpecs from 'Stores/randys-worldwide/Templates/FacetDialogVehicleSpecs.rt'
import { SearchBoxDialog } from 'Components'
import TemplateSearchBoxDialog from 'Stores/_default-store/Templates/SearchBoxDialog.rt'
import { AutoSyncVisualizationDialog } from 'Components'
import TemplatefitmentSearchautoSyncVisualizationDialog from 'Stores/_default-store/Templates/fitmentSearch/autoSyncVisualizationDialog.rt'
import { SearchBoxDialogButton } from 'Components'
import TemplatesearchBoxdialogButtonAdaptable from 'Stores/_default-store/Templates/searchBox/dialogButtonAdaptable.rt'
import { SearchBox } from 'Components'
import TemplateKeywordsSearchPage from 'Stores/randys-worldwide/Templates/KeywordsSearchPage.rt'
import TemplateDifferentialSearchPage from 'Stores/randys-worldwide/Templates/DifferentialSearchPage.rt'
import TemplatedifferentialsDifferentialSelectionPage from 'Stores/randys-worldwide/Templates/differentials/DifferentialSelectionPage.rt'
import TemplatefitmentSearchhomeVehicleWidget from 'Stores/randys-worldwide/Templates/fitmentSearch/homeVehicleWidget.rt'
import TemplatefitmentSearchsearchVehicleWidgetContainer from 'Stores/_default-store/Templates/fitmentSearch/searchVehicleWidgetContainer.rt'
import { DialogButton } from 'Components'
import TemplatefitmentSearchmobileGarage from 'Stores/randys-worldwide/Templates/fitmentSearch/mobileGarage.rt'
import { VerifyFitment } from 'Components'
import TemplatefitmentSearchverifyFitment from 'Stores/yukongear/Templates/fitmentSearch/verifyFitment.rt'
import { FitmentTable } from 'Components'
import TemplatefitmentSearchfitmentTable from 'Stores/_default-store/Templates/fitmentSearch/fitmentTable.rt'
import { VehicleWidgetDialog } from 'Components'
import TemplatefitmentSearchdialog from 'Stores/randys-worldwide/Templates/fitmentSearch/dialog.rt'
import TemplatefitmentSearchdifferentialDialog from 'Stores/randys-worldwide/Templates/fitmentSearch/differentialDialog.rt'
import { ContextDialog } from 'Components'
import TemplatedifferentialsDifferentialBrandSelectionDialog from 'Stores/randys-worldwide/Templates/differentials/DifferentialBrandSelectionDialog.rt'
import TemplatedifferentialsDifferentialSelectionDialog from 'Stores/randys-worldwide/Templates/differentials/DifferentialSelectionDialog.rt'
import TemplatemainsortDialog from 'Stores/randys-worldwide/Templates/main/sortDialog.rt'

export const compMap = {
  SearchPage,
FacetTiles,
FacetPanel,
FacetBar,
SearchResult,
SearchHeader,
VehicleWidget,
RequestPanel,
Garage,
SingleVehicleGarage,
RelatedItems,
BuyItemsTogether,
FacetDialog,
SearchBoxDialog,
AutoSyncVisualizationDialog,
SearchBoxDialogButton,
SearchBox,
DialogButton,
VerifyFitment,
FitmentTable,
VehicleWidgetDialog,
ContextDialog
}
export const tplMap = {
  'SearchPage': TemplateSearchPage,
'facetTiles/subtitles': TemplatefacetTilessubtitles,
'fitmentSearch/collapsibleVehicleWidget': TemplatefitmentSearchcollapsibleVehicleWidget,
'HomeWheelTireBar': TemplateHomeWheelTireBar,
'fitmentSearch/garage': TemplatefitmentSearchgarage,
'fitmentSearch/singleVehicleGarage': TemplatefitmentSearchsingleVehicleGarage,
'facetTiles/hierarchicalContainer': TemplatefacetTileshierarchicalContainer,
'facetTiles/alphabeticalContainer': TemplatefacetTilesalphabeticalContainer,
'product/relatedItems': TemplateproductrelatedItems,
'product/boughtTogether': TemplateproductboughtTogether,
'FacetDialogVehicleSpecs': TemplateFacetDialogVehicleSpecs,
'SearchBoxDialog': TemplateSearchBoxDialog,
'fitmentSearch/autoSyncVisualizationDialog': TemplatefitmentSearchautoSyncVisualizationDialog,
'searchBox/dialogButtonAdaptable': TemplatesearchBoxdialogButtonAdaptable,
'KeywordsSearchPage': TemplateKeywordsSearchPage,
'DifferentialSearchPage': TemplateDifferentialSearchPage,
'differentials/DifferentialSelectionPage': TemplatedifferentialsDifferentialSelectionPage,
'fitmentSearch/homeVehicleWidget': TemplatefitmentSearchhomeVehicleWidget,
'fitmentSearch/searchVehicleWidgetContainer': TemplatefitmentSearchsearchVehicleWidgetContainer,
'fitmentSearch/mobileGarage': TemplatefitmentSearchmobileGarage,
'fitmentSearch/verifyFitment': TemplatefitmentSearchverifyFitment,
'fitmentSearch/fitmentTable': TemplatefitmentSearchfitmentTable,
'fitmentSearch/dialog': TemplatefitmentSearchdialog,
'fitmentSearch/differentialDialog': TemplatefitmentSearchdifferentialDialog,
'differentials/DifferentialBrandSelectionDialog': TemplatedifferentialsDifferentialBrandSelectionDialog,
'differentials/DifferentialSelectionDialog': TemplatedifferentialsDifferentialSelectionDialog,
'main/sortDialog': TemplatemainsortDialog
};